import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { Product } from '~app/modules/account/modules/buy-again/models';

export class ExploreSimilarProductsClickBuyAgainApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.ExploreSimilarProductsClickBuyAgain;

  constructor(private product: Product) {}

  getPayload(): { product: Product } {
    return {
      product: this.product,
    };
  }
}
